import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp";

const MAPBOX_ACCESS_TOKEN =
  "pk.eyJ1IjoibWFudXF0IiwiYSI6ImNtYXpiaTFvYTBpdjkybHM2cDh2ZDNsZWYifQ.ZNVYdYytEcJUWsVSnTt4lw";

mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

// CRA production Babel rewrites Mapbox's inlined worker and blanks the map
// (ReferenceError: r/o is not defined). Load the worker as its own file.
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default; // eslint-disable-line import/no-webpack-loader-syntax, import/no-unresolved

export default MAPBOX_ACCESS_TOKEN;
export { mapboxgl };
